import React, { useState } from 'react'
import { FieldTypes } from '../../utils/constants'
import Form from '../common/Form'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import ListHeader from '../common/ListHeader'
import useStyles from '../common/FormFields/FormFieldsStyle'

export default function ApartmentForm({
  buildingId,
  onSubmit,
  handleCancel,
  apartment,
}) {
  const classes = useStyles()
  const history = useHistory()

  const [values, setValues] = useState(apartment ?? {})

  return (
    <div className={classes.paper}>
      <ListHeader
        bigTitle={`${
          apartment && apartment.id ? 'Editar' : 'Nuevo'
        } apartamento`}
        canCreate={false}
      />
      <Form
        values={values}
        setValues={setValues}
        fields={[
          {
            type: FieldTypes.TextField,
            label: 'Nombre',
            hint: 'Ingrese un nombre',
            key: 'name',
            errorMessage: 'El nombre es requerido',
          },
          {
            type: FieldTypes.TextField,
            label: 'Usuario SIP',
            hint: 'Ingrese un usuario SIP',
            key: 'sipUser',
            errorMessage: 'El usuario SIP es requerido',
          },
          {
            type: FieldTypes.TextField,
            label: 'Contraseña SIP',
            hint: 'Ingrese una contraseña SIP',
            key: 'sipPassword',
            errorMessage: 'La contraseña SIP es requerida',
          },
          {
            type: FieldTypes.TextField,
            label: '# Notificación',
            hint: 'Ingrese un # notificación',
            key: 'notificationNumber',
            errorMessage: 'El # notificación es requerido',
          },
          {
            type: FieldTypes.TextField,
            label: 'Pisos habilitados',
            hint: 'Ej: 1,2,5 (dejar vacío para usar el número de apartamento)',
            key: 'enabledFloors',
          },
        ]}
        handleSubmit={() => {
          onSubmit(values)
        }}
        handleCancel={handleCancel}
      />
    </div>
  )
}
